import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";

const OperationAreaPopup = ({ closePopup, editData, triggerReload }) => {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (editData?.id) {
      const fetchData = async () => {
        try {
          const response = await axiosInstance.get(`/costsolution/operationarea/get/${editData.id}`);
          setCode(response.data.operationarea?.code || "");
          setName(response.data.operationarea?.name || "");
          setIsEditing(true);
        } catch (error) {
          toast.error("Failed to fetch operation area details");
          console.error("Fetch error:", error);
        }
      };
      fetchData();
    } else {
      setCode("");
      setName("");
      setIsEditing(false);
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, name };

    try {
      const url = isEditing
        ? `/costsolution/operationarea/${editData?.id}`
        : '/costsolution/operationarea';

      const method = isEditing ? 'put' : 'post';

      await axiosInstance[method](url, postData);

      toast.success(isEditing ? "Operation area updated successfully!" : "Operation area created successfully!");
      triggerReload();
      closePopup();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save operation area");
      console.error("Save error:", error);
    }
  };

  const handleClear = () => {
    setCode("");
    setName("");
  };

  return (

      <div className="scope-creation-popup-overlay">
        <div className="scope-creation-popup-container">
          <div className="scope-creation-popup-header">
            <h2>{isEditing ? 'Edit Operation Area' : 'Create New Operation Area'}</h2>
            <button className="close-button" onClick={closePopup}>×</button>
          </div>

          <form onSubmit={handleSubmit}>
          <div className="scope-creation-popup-body">
            <div className="scope-creation-form-group">
              <label htmlFor="code">Code</label>
              <input
                type="text"
                id="code"
                name="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                style={{margin:'0px'}}
              />
            </div>
            <div className="scope-creation-form-group">
              <label htmlFor="category" className='name'>Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{margin:'0px'}}
              />
            </div>
          </div>
          <div className="scope-creation-popup-footer">
            <button type="button" className='scope-clear-button' onClick={handleClear}>Clear</button>
            <button className="scope-submit-button" onClick={handleSubmit}>
              {isEditing ? 'Update' : 'Submit'}
            </button>
          </div>
          </form>
        </div>  
      </div>

  );
}

export default OperationAreaPopup;